<template>
    <div class="all-order descriptions1" >
        <div class="all-order-content">
            <div style="padding: 20px;;width: 60%" v-if="descriptionsData.name">
                <el-descriptions title="" :column="1" border>
                    <el-descriptions-item label="公司名称">{{descriptionsData.name}}</el-descriptions-item>
                    <el-descriptions-item label="英文名称">{{descriptionsData.nameEn}}</el-descriptions-item>
                   
                </el-descriptions>
            </div>

            <div class="" v-else>
                <el-empty description="展商还未提交此内容">
                    <p>截止时间为：{{ timeValue }}，可提醒展商及时提交信息</p>

                </el-empty>
            </div>
        </div>
    </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";

export default {
    name: "all-order",
    props:{
        timeValue:String
    },
    data () {
        return {
            list: [],
            descriptionsData: {},

        }
    },
    computed: {
        ...mapGetters({
            exhibitor: "loginModule/getExhibitor",
        }),
        queryId () {
            return this.$route.query.id;
        },

    },
    mounted () {
        this.init()
    },
    methods: {
        ...mapActions({
            setManageSettingQ: 'hostSetModule/setManageSettingQ', //获取
            getfreerecordList: 'exhibitionModule/getfreerecordList', //获取会刊免费登记记录
            getjournalfreerecord: 'exhibitionModule/getjournalfreerecord', //修改

            lintelRecordAsync: 'hostSetModule/lintelRecordAsync', //修改
        }),
        goDetail () {
            this.$router.push('/exhibition/index/order/detail-order');
        },
        async init () {
         
            let res1 = await this.lintelRecordAsync(this.queryId)
            if(res1){
              this.descriptionsData=res1
            }

        },
    }
}
</script>
<style lang="scss">
   .descriptions1{
      th{
        width: 220px;
      }
      td{
        width: 300px;
      }
   }

</style>

<style lang="scss" scoped>
.all-order {
    min-width: 1000px;
    padding: 30px;
    min-height: 500px;
    &-content {
        background: #FFF;

        .goods {
            width: 18%;
            padding: 10% 0;
            display: inline-block;
            position: relative;
            margin: 0 3px;

            img {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                max-width: 100%;
                max-height: 100%;
                margin: auto;
            }
        }

        .goods-e {
            position: absolute;
            left: 100%;
            top: 30%;
            font-weight: bold;
        }

        .operation {
            color: #1890ff;
            cursor: pointer;
        }
    }
}


</style>